import React from 'react';

const LayoutHeader = ({ toggleSidebar, currentUser, setCurrentUser }) => {
  // Sin valor por defecto: si academy_name viene vacío, no se muestra texto
  const academyName = currentUser?.academy_name ?? '';
  const academyLogo = currentUser?.academy_logo ?? '';

  const handleLogout = () => {
    fetch('/api/logout.php', { method: 'POST', credentials: 'include' })
      .then(() => {
        setCurrentUser(null);
        window.location.reload();
      });
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-white text-black p-4 shadow-lg z-50 flex justify-between items-center">
      {/* Botón menú izquierdo */}
      <button onClick={() => toggleSidebar('left')} className="text-black focus:outline-none">
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
            d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {/* Centro: logo + nombre de la academia */}
      <div className="flex items-center flex-grow justify-center">
        {academyLogo && (
          <img
            src={academyLogo}
            alt="Logo de la Academia"
            className="h-10 w-auto object-contain mr-2"
          />
        )}
        {academyName && (
          <span className="text-xl font-semibold text-black hidden sm:block">
            {academyName}
          </span>
        )}
      </div>

      {/* Sección derecha */}
      <div className="flex items-center space-x-4">
        {currentUser && (
          <>
            <span className="hidden md:block text-sm">
              Hola, <span className="font-semibold">{currentUser.username}</span>
            </span>
            <button
              onClick={handleLogout}
              className="px-3 py-1 bg-gray-200 text-gray-800 rounded-md text-sm hover:bg-gray-300 transition-colors duration-200"
            >
              Cerrar Sesión
            </button>
          </>
        )}
        <button onClick={() => toggleSidebar('right')} className="text-black focus:outline-none">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7" />
          </svg>
        </button>
      </div>
    </header>
  );
};

export default LayoutHeader;

